const mutations = {
    /**
     * sets active section
     *
     * @param {object} context
     * @param {int} index
     */
    setActiveSection(context, index) {
        context.activeSection = index;
    },

    /**
     * shows navigation
     *
     * @param {object} context
     */
    showNavigation(context) {
        context.navigationVisible = true;
    },
};

export default mutations;
